import styled from 'styled-components'

import { TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'
import { Dialog } from '@syconium/little-miss-figgy/dist/components'

export const SizeChartButton = styled.button`
  ${TypeStyle.css.headlineMicro};
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-start: auto;
  text-decoration: underline;

  &:hover {
    color: ${o => o.theme.color.deprecated.obsidianLight};
  }
`

export const SectionSubtitle = styled(TypeStyle.HeadlineMicro)`
  font-weight: normal;
`

export const DialogModal = styled(Dialog.Modal)`
  max-width: 1100px;
  width: 100%;

  ${untilMd} {
    height: 100%;
  }
`

export const ModalContent = styled.div`
  ${fromMd} {
    height: 768px;
    overflow: auto;
  }
`

export const ModalHeader = styled(TypeStyle.HeadlineSmall)``
